import React from 'react';
import css from '../ResearchWinesPage.module.css';

function FilterByWinePrice({ selectedPriceRange, setSelectedPriceRange}) {
  const priceRanges = [
    {
      start: 0,
      end: 10.99,
    },
    {
      start: 11,
      end: 19.99,
    },
    {
      start: 20,
      end: 29.99,
    },
    {
      start: 30,
      end: 39.99,
    },
    {
      start: 40,
      end: 49.99,
    },
    {
      start: 50,
      end: 59.99,
    },
    {
      start: 60,
      end: 79.99,
    },
    {
      start: 80,
      end: 0,
    },
  ]

  const isChecked = (range) => {
    if(range.start === selectedPriceRange.start && range.end === selectedPriceRange.end) {
      return true;
    }
    return false;
  };
  const handleOnChange = (e, range) => {
    if(e.target.checked){
      setSelectedPriceRange({...selectedPriceRange, start: range.start, end: range.end})
    } else {
      setSelectedPriceRange({...selectedPriceRange, start: 0, end: 0})
    }
  }

  return (
    <div>
      <h3>Wine Price</h3>
      <div>
        {priceRanges.map((range, index) => (
          <div key={index} style={{display: 'flex', alignItems: 'center'}}>
            <input
              type="checkbox"
              id={`id${range.start}`}
              onChange={(e) => handleOnChange(e, range)}
              checked={isChecked(range)}
              style={{display: 'inline-block', width: 'auto', marginRight: "10px"}}
            />
            <label htmlFor={`id${range.start}`}>
              {
                range.start === 0 ? `< $${range.end}` :
                range.end === 0 ? `> $${range.start}` :
                `$${range.start} - $${range.end}`
              }
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterByWinePrice
